module.exports = __webpack_public_path__ + "img/s51.5b672449.png";